import { openDrawer } from "../api/services/devices/cashDrawer";
import {
  printMedicationLabel,
  printPatientSticker,
  printQueueTicket,
} from "../api/services/devices/printer";

interface QueueTicketPayload {
  queue_info?: {
    queue_number?: string;
    filename?: string;
    pdf_base64?: string;
  };
}

interface PatientStickerPayload {
  patient_info?: {
    filename?: string;
    pdf_base64?: string;
    sticker_count?: number;
  };
}

interface MedicineStickerPayload {
  medication_info?: {
    filename?: string;
    pdf_base64?: string;
  };
}

export const handleQueueTicketEvent = (
  payload: QueueTicketPayload = {},
): void => {
  const queueNumber = payload?.queue_info?.queue_number;
  const filename = payload?.queue_info?.filename;
  const pdfBase64 = payload?.queue_info?.pdf_base64;

  if (!pdfBase64) {
    return;
  }

  printQueueTicket({
    pdf_base64: pdfBase64,
    filename,
    queueNumber,
  }).catch((error) => {
    console.error("Failed to print queue ticket", error);
  });
};

export const handlePatientStickerEvent = (
  payload: PatientStickerPayload = {},
): void => {
  const filename = payload?.patient_info?.filename;
  const pdfBase64 = payload?.patient_info?.pdf_base64;
  const pages = payload?.patient_info?.sticker_count;

  if (!pdfBase64) {
    return;
  }

  printPatientSticker({
    pdf_base64: pdfBase64,
    filename,
    pages,
  }).catch((error) => {
    console.error("Failed to print patient sticker", error);
  });
};

export const handleMedicineStickerEvent = (
  payload: MedicineStickerPayload = {},
): void => {
  const filename = payload?.medication_info?.filename;
  const pdfBase64 = payload?.medication_info?.pdf_base64;

  if (!pdfBase64) {
    return;
  }

  printMedicationLabel({
    pdf_base64: pdfBase64,
    filename,
  }).catch((error) => {
    console.error("Failed to print medicine sticker", error);
  });
};

export const handleOpenCashDrawerEvent = (): void => {
  openDrawer().catch((error) => {
    console.warn("Failed to open cash drawer", error);
  });
};
